import { render, staticRenderFns } from "./payoutListDetails.vue?vue&type=template&id=28e94af2&scoped=true"
import script from "./payoutListDetails.vue?vue&type=script&lang=js"
export * from "./payoutListDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e94af2",
  null
  
)

export default component.exports